export default __webpack_public_path__ + "static/media/inlandBlueHole2.a5ec31b0.webp";